import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { DEFAULT_DATE_PROPERTIES, defaultFirestoreConverter } from '../../core/db/firestore.helper';
import type { DraftOrder } from '../order/order.models';
import { ReferrerMonthlyTracking, UserModel } from './user.models';

export const draftOrderFirestoreConverter = defaultFirestoreConverter<DraftOrder>(
  [...DEFAULT_DATE_PROPERTIES, 'cart.createdAt', 'cart.updatedAt']
);

export const referrerMonthlyTrackingConverter = defaultFirestoreConverter<ReferrerMonthlyTracking>(
  [...DEFAULT_DATE_PROPERTIES, 'date']
);

@Injectable({ providedIn: 'root' })
export class UserDbService extends FirestoreBase<UserModel> {

  constructor(firestore: Firestore) {
    super(
      'users',
      firestore,
      { dateProperties: ['locationUpdated'], allowGetAll: true });
  }

}
